_ = require 'underscore'
CardAgingCardButtonView = require 'app/scripts/views/card-aging/card-aging-card-button-view'
CardLocationButtonView = require 'app/scripts/views/map/card-location-button-view'
Controller = require 'app/scripts/controller'
CustomFieldCardButtonView = require 'app/scripts/views/custom-field/custom-field-card-button-view'
PluginButtonsView = require 'app/scripts/views/plugin/plugin-buttons-view'
PluginCardButtonView = require 'app/scripts/views/plugin/plugin-card-button-view'
sidebarAction = require 'app/scripts/views/templates/card_detail_sidebar_button'
{ dontUpsell } = require '@trello/config'
React = require 'react'
{ renderUpgradePrompt } = require 'app/src/components/UpgradePrompts/renderUpgradePrompt'
{ PupUpgradePromptSection } = require './PupUpgradePromptSection'
{ IconName } = require 'app/common/components/controls/icon'
l = require 'app/scripts/lib/localize'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_detail')
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
Auth = require 'app/scripts/db/auth'

CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
BUTLER_POWER_UP_ID = require 'app/scripts/data/butler-id'

_placeholderCountCache = {}

nativeCustomFieldsEnabled = (board) ->
  board.isPluginEnabled(CUSTOM_FIELDS_ID) &&
  board.editable()

template = t.renderable ({ showGetPups, hasButtons, placeholders }) ->
  t.h3 'mod-no-top-margin', ->
    t.format 'plugins'
  t.div '.u-clearfix.js-button-list', ->
    if placeholders
      _.times placeholders, ->
        t.a ".button-link.disabled", ->
          t.span ''

  if showGetPups
    t.div ->
      t.a '.button-link.js-get-pups.get-pups', {
        href: '#'
        title: if hasButtons || placeholders then t.l('get-more-pups') else t.l('get-pups')
      }, ->
        if hasButtons || placeholders
          t.format 'get-more-pups'
        else
          t.format 'get-pups'
      t.div '.js-card-back-pup-prompt'


module.exports = class PluginCardButtonsView extends PluginButtonsView
  tagName: 'div'
  className: 'window-module u-clearfix hide'
  buttonsSelector: '.js-button-list'
  buttonView: PluginCardButtonView
  events:
    'click .js-get-pups': 'showPowerUps'

  remove: ->
    @unmountPupPrompt?()
    super

  _getPlaceholderCountCacheKey: ->
    "#{@model.getBoard().id}:#{@model.getBoard().idPluginsEnabled().sort().join(':')}"

  getPlaceholderCount: ->
    placeholders = 0

    placeholderCountCacheKey = @_getPlaceholderCountCacheKey()
    if _placeholderCountCache[placeholderCountCacheKey]
      placeholders = _placeholderCountCache[placeholderCountCacheKey]
    else
      # we are going to make a guesstimate on how many buttons we can expect
      # our assumption is that a plugin that declares it supports the 'card-buttons'
      # capability is most likely to give us back exactly one button
      # NOTE: plugins are loading asynchronously from the board and speed here matters
      # that means if a person loads a card directly, its possible the actual plugins
      # haven't loaded yet, so we won't wait on them, we'll skip them
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      if !@model.getBoard().editable()
        return placeholders
      ModelCache = require 'app/scripts/db/model-cache'

      includeIf = (plugin) ->
        plugin? &&
        _.contains(plugin.get('capabilities'), 'card-buttons') &&
        # https://trello.com/c/xozF2u4V: by default, Butler does not return card buttons,
        # but is also always enabled for every user, so we ignore it
        # to prevent a more common "off by one" placeholder issue
        plugin.id != BUTLER_POWER_UP_ID

      placeholders = @model.getBoard().idPluginsEnabled()
        .map((idPlugin) -> ModelCache.get('Plugin', idPlugin))
        .filter(includeIf)
        .length

    return placeholders

  hideContainer: (pluginButtons) ->
    if !pluginButtons?
      # no placeholders and not editable
      @placeholderCount == 0 && !@model.getBoard().editable()
    else
      # no buttons and not editable
      pluginButtons.length == 0 && !@model.getBoard().editable()

  renderContainer: (pluginButtons, loading = false) ->
    board = @model.getBoard()
    hasButtons = pluginButtons.length > 0
    showGetPups = board.editable()
    placeholders = if !loading then 0 else @getPlaceholderCount()

    if loading
      @placeholderCount = placeholders

    @$el.html(template({ hasButtons, showGetPups, placeholders }))

    upgradeUrl = Controller.getUpgradeUrl(board)

    @unmountPupPrompt = renderUpgradePrompt(
      React.createElement(PupUpgradePromptSection, { upgradeUrl, orgId: @model.getBoard().getOrganization()?.id })
      , @$el.find('.js-card-back-pup-prompt')[0]
      , {
        boardModel: board
        extraCondition: -> board.editable()
      }
    )

    @$('.js-button-list')

  renderButtons: (pluginButtons) ->
    board = @model.getBoard()

    if nativeCustomFieldsEnabled(board)
      pluginButtons.push
        text: t.l('custom-fields')
        view: CustomFieldCardButtonView

    if board.isMapPowerUpEnabled() && board.editable()
      pluginButtons.push
        text: t.l('location')
        view: CardLocationButtonView

    if board.isPowerUpEnabled('cardAging') && board.editable()
      pluginButtons.push
        text: t.l('card-aging')
        view: CardAgingCardButtonView

    super(pluginButtons)

    actualCount = @$('.js-button-list').children().length
    _placeholderCountCache[@_getPlaceholderCountCacheKey()] = actualCount

  runnerOptions: ->
    command: 'card-buttons'
    board: @model.getBoard()
    card: @model

  renderOnce: ->
    @renderContainer([], true)
    @$el.toggleClass('hide', @hideContainer())
    super

  showPowerUps: (e) ->
    Util.stop(e)

    if !Controller.onAnyBoardView()
      window.open('/power-ups', '_blank')
      return

    boardView = Controller.getCurrentBoardView()
    boardView.navigateToDirectory(@model)
    trackUe('board view', 'opens', 'Power-Up directory home page', '', '', 'by clicking Power-Ups link on card-back')
